import React from "react";
import RegisterImg from "../images/register.png";
import ApiCallingService from '../../service/api-call-service';
import { connect } from 'react-redux';
import { store } from '../../redux/store';
import XMLParser from 'react-xml-parser';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { showIciciKycSuccessSection } from '../../redux/div-show-and-hide/div-show-and-hide.action';
import $ from 'jquery';

var finalUrl = "";
var MethodInfo = "";
var MethodCapture = "";
var finalport = "";
var is_capture = false;
var deviceInfo = '';
var finalRdServiceResponse = [];

class IciciKyc extends React.Component{
    constructor(props){
        super(props);
        this.state={
			curTime: new Date().toLocaleString(),
			messagePopUpHidden: false,
            message: '',
            severity: '',
			otp: '',
			getOtpBtn: true,
			resendOtpBtn: false,
			proceedButtonStatus: true,
			checkTermsConditions: 0,
			biomatricDeviceIndicaterClass:'',
			biomatricDeviceIndicater: 'Please connect biometric device.',
			RDdeviceInfo: '',
			CaptureFingerprintData: '',
			isBiomatricConnected: false,
			primaryKeyId: '',
			encodeFPTxnId: ''
        }
    }
    
	componentDidMount = () => {
		setInterval(()=>{
                this.findbiomatricDevice();
            }, 9000);
    }

	findbiomatricDevice = ()=>{
        var discoverRDServiceResponse =  this.discoverRDService();
        var discoverRDServiceFinalResponse = new XMLParser().parseFromString(discoverRDServiceResponse.data);
      
        var info = discoverRDServiceFinalResponse!=undefined && discoverRDServiceFinalResponse.attributes.info!=undefined? discoverRDServiceFinalResponse.attributes.info:'';
        var status = discoverRDServiceFinalResponse!=undefined && discoverRDServiceFinalResponse.attributes.status!=undefined? discoverRDServiceFinalResponse.attributes.status:'';
      
        if(status=="NOTREADY"){
            this.setState({biomatricDeviceIndicaterClass:"disconnect"});
        }else{
         this.setState({biomatricDeviceIndicaterClass:"connect"});
        }
        this.setState({ biomatricDeviceIndicater: info }); 

        console.log("BiomatricDeviceIndicaterClass : "+this.state.biomatricDeviceIndicaterClass);

    }

	discoverRDService = () => {
        var primaryUrl = process.env.REACT_APP_RDService_URL;
        var tempcount = 0;
        var url = "";
        $("#ddlRDS").empty();

        for (var i = 11100; i <= 11120; i++) {
            var verb = "RDSERVICE";
            var err = "";

            var res;
            $.support.cors = true;
            var httpStaus = false;
            var jsonstr = "";
            var data = new Object();
            var obj = new Object();
            var xmlstr;

            $.ajax({
                type: "RDSERVICE",
                async: false,
                crossDomain: true,
                url: primaryUrl + i.toString(),
                contentType: "text/xml; charset=utf-8",
                processData: false,
                cache: false,
                async: false,
                crossDomain: true,

                success: function (data) {
                    try {
                        xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                        
                        data = xmlstr;

                        httpStaus = true;
                        res = { httpStaus: httpStaus, data: data };
                        	
                        finalUrl = primaryUrl + i.toString();

                        var $doc = $.parseXML(xmlstr);
                        var CmbData1 = $($doc).find('RDService').attr('status');
                        var CmbData2 = $($doc).find('RDService').attr('info');

                        $("#ddlRDS").append('<option value=' + i.toString() + '>Port : ' + i.toString() + ' Status : ' + CmbData1 + '(' + CmbData2 + ')</option>')
                        tempcount++;
                    }
                    catch (e) { }
                },
                error: function (msg) {
                    var result = msg.status + msg.statusText + msg.responseText;
                    res = { httpStaus: false, data: data };

                }
               
            });

            if (xmlstr != null) {
                if (xmlstr.indexOf('Precision') > 0) {

                    $("select#ddlRDS").prop('selectedIndex', tempcount - 1);
                    finalport = i.toString();
                    this.discoverFirstNode(i);
                    break;
                }
            }

        }
        return res;

    }

	discoverFirstNode = (PortNo) => {
        $('#txtDeviceInfo').val('');
        $('#txtPidOptions').val('');
        $('#txtPidData').val('');

        var primaryUrl = process.env.REACT_APP_RDService_URL;
        let url = "";
        var verb = "RDSERVICE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        var data = new Object();
        var obj = new Object();

        $.ajax({
            type: "RDSERVICE",
            async: false,
            crossDomain: true,
            url: primaryUrl + PortNo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            cache: false,
            async: false,
            crossDomain: true,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                data = xmlstr;                
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };                	
                $('#txtRDSInfo').val(data);
                var $doc = $.parseXML(data);
                for (var j = 0; j < 2; j++) {
                    if ($($doc).find('Interface').eq(j).attr('id') == 'CAPTURE') {
                        MethodCapture = $($doc).find('Interface').eq(j).attr('path');
                    } else if ($($doc).find('Interface').eq(j).attr('id') == 'DEVICEINFO') {
                        MethodInfo = $($doc).find('Interface').eq(j).attr('path');
                    }
                } 

                console.log("Precision RDSERVICE Discover Successfully");
                var parser = new DOMParser();
                var device1_response = parser.parseFromString($doc, "text/xml");
                is_capture = true;
            },
            error: function (msg) {
                is_capture = false;
                var result = msg.status + msg.statusText + msg.responseText;
                alert(result);

            }
        });
        this.deviceInfo();
       
        return res;

    }

	deviceInfo = () => {
        var url = "";
        finalUrl = process.env.REACT_APP_RDService_URL + finalport;
        var verb = "DEVICEINFO";        
        var err = "";
        var res;        
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "DEVICEINFO",
            async: false,
            crossDomain: true,
            url: finalUrl + MethodInfo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);                
                data = xmlstr;               
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };
                $('#txtDeviceInfo').val(data);
                deviceInfo = data;
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                console.log("Error In device info", result);
            }
        });
        var RDdeviceInfoXml = new XMLParser().parseFromString(deviceInfo);
        this.setState({ RDdeviceInfo: RDdeviceInfoXml })
        return res;
    }

	capture = (event) => {

        var fCount = document.getElementById('txtfcount').value;
        var fType = document.getElementById('txtftype').value;
        var format = document.getElementById('txtformat').value;
        var pidver = document.getElementById('txtPidVer').value;
        var timeout = document.getElementById('txttimeout').value;
        var env = document.getElementById('txtenv').value;
        var lock = document.getElementById('txtlk').value;

        finalUrl = process.env.REACT_APP_RDService_URL + finalport;
        console.log("Capture_", finalUrl);
        var XML = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="' + fCount + '" fType="' + fType + '" format="' + format + '" pidVer="' + pidver + '" timeout="' + timeout + '" env="' + env + '" wadh="' + process.env.REACT_APP_FingPay_Wadh_Value + '" /> <CustOpts> <Param name="LockingKey" value="' + lock + '" /> </CustOpts> </PidOptions>';
        console.log("XML_data_", XML);
        var verb = "CAPTURE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "CAPTURE",
            async: false,
            crossDomain: true,
            url: finalUrl + MethodCapture,
            data: XML,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);                
                data = xmlstr;               
                httpStaus = true;
                var isBiomatric = true;
                res = { httpStaus: httpStaus, data: data };
                finalRdServiceResponse = data;
                $('#txtPidData').val(data);
                $('#txtPidOptions').val(XML);
                var $doc = $.parseXML(data);
                var Message = $($doc).find('Resp').attr('errInfo');
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                res = { httpStaus: false, data: result };
                alert("Please reconnect biometric device.");
                console.log("Error in Finger print capture ", res);
            }
        });
        
		this.setState({ isBiomatricConnected: false });
     
        return res;
    }

	onClickGetOtp = async (event) => {

		var long = '';
        var lat = '';
        navigator.geolocation.watchPosition(async function (position) {
            long = position.coords.longitude;
            lat = position.coords.latitude;
            console.log("Latitude is :", position.coords.latitude);
            console.log("Longitude is :", position.coords.longitude);
        });

		const request = {
			"request": {
			  "merchantLoginId": this.props.orderDetails.roMdn,
			  "mobileNumber": this.props.mobile,
			  "aadharNumber": this.props.aadhaarNumber,
			  "panNumber": this.props.panNumber,
			  "matmSerialNumber":"",
			  "latitude": "22.9734229", //lat,
			  "longitude": "78.6568942", //long,
			  "timestamp": this.state.curTime,
			  "deviceImei": "F58032B1-496D-44E1-950F-BB8DC4F362A9"
			 
			}
		}

		console.log('Send Otp request', request);

		var url = process.env.REACT_APP_FingPay_Send_Otp_URL;

		console.log('Send Otp url', url);

		var response = await ApiCallingService.postMethodCall(url, request);

		console.log('Send Otp response', response);

        if (!(response === undefined) && (response.response_code == 0)) {
			this.setState({ primaryKeyId: response.response.data.primaryKeyId });
			this.setState({ encodeFPTxnId: response.response.data.encodeFPTxnId });

			this.setState({messagePopUpHidden: true });
			this.setState({severity: "success" });
			this.setState({message:response.response_description});		
		}
		else if (!(response === undefined) && !(response.response_description === undefined)) {
			this.setState({messagePopUpHidden: true });
			this.setState({severity: "error" });
			this.setState({message: response.response_description });
				
		} else {
			this.setState({messagePopUpHidden: true })
			this.setState({message:response});
			this.setState({severity: "error" });
		}
		
		this.setState({ getOtpBtn: false });
		this.setState({ resendOtpBtn: true });
    }

	onClickResendOtp = async (event) => {
        const request = {
			"request": {
				"merchantLoginId": this.props.orderDetails.roMdn,
				"primaryKeyId": this.state.primaryKeyId,
				"encodeFPTxnId": this.state.encodeFPTxnId,
				"timestamp": this.state.curTime,
				"deviceImei": "F58032B1-496D-44E1-950F-BB8DC4F362A9"
				 
			}
		}

		console.log('Resend Otp request', request);

		var url = process.env.REACT_APP_FingPay_Resend_Otp_URL;

		console.log('Resend Otp url', url);

		var response = await ApiCallingService.postMethodCall(url, request);

		console.log('Resend Otp response', response);

        if (!(response === undefined) && (response.response_code == 0)) {

			this.setState({ primaryKeyId: response.response.data.primaryKeyId });
			this.setState({ encodeFPTxnId: response.response.data.encodeFPTxnId });

			this.setState({messagePopUpHidden: true });
			this.setState({severity: "success" });
			this.setState({message:response.response_description});		
		}
		else if (!(response === undefined) && !(response.response_description === undefined)) {
			this.setState({messagePopUpHidden: true });
			this.setState({severity: "error" });
			this.setState({message: response.response_description });
				
		} else {
			this.setState({messagePopUpHidden: true })
			this.setState({message:response});
			this.setState({severity: "error" });
		}
    }

	handleChange = (event) => {
		const { value, name } = event.target;
		this.setState({ [name]: value });

		setTimeout(() => {
			this.formValidation();
	    }, 300);
    };

    handleBackClick = (event) => {
    }

	submitFormData = async (event) => {
        event.preventDefault();

		const request = {
			"request": {
				"merchantLoginId": this.props.orderDetails.roMdn,
				"otp": this.state.otp,
				"primaryKeyId": this.state.primaryKeyId,
				"encodeFPTxnId": this.state.encodeFPTxnId,
				"timestamp": this.state.curTime,
				"deviceImei": "F58032B1-496D-44E1-950F-BB8DC4F362A9"
			}
		}

		console.log('Validate Otp request', request);

		var url = process.env.REACT_APP_FingPay_Validate_Otp_URL;

		console.log('Validate Otp url', url);

		var response = await ApiCallingService.postMethodCall(url, request);

		console.log('Validate Otp response', response);

        if (!(response === undefined) && (response.response_code == 0)) {

			//setTimeout(() => {
				if (is_capture == true) {
					var captureData = this.capture();
					console.log("CaptureData : ",captureData);
                	var Fingerprintxml = new XMLParser().parseFromString(captureData.data);
                	var errCode  = Fingerprintxml.children[0].attributes.errCode!=undefined?Fingerprintxml.children[0].attributes.errCode:'';
                	console.log("Fingerprintxml data : ",Fingerprintxml.children[0].attributes.errCode);

					if(errCode == 0){
						this.setState({ CaptureFingerprintData: Fingerprintxml });
						
						this.setState({ messagePopUpHidden: true })
                		this.setState({message:"Finger Print capture successfully."});
                		this.setState({ severity: "success" });
							
					}else{
						var errInfo = Fingerprintxml.children[0].attributes.errInfo!=undefined?Fingerprintxml.children[0].attributes.errInfo:'';
						Fingerprintxml=[];
						this.setState({ messagePopUpHidden: true })
						this.setState({message:errInfo});
						this.setState({ severity: "error" });
					}
					console.log("CaptureFingerprintDataResponse : ", JSON.stringify(this.state.CaptureFingerprintData));
            		console.log("Fingerprintxml : ", Fingerprintxml);
        		}
			//}, 300);

			var finalDeviceInfo = this.state.RDdeviceInfo != null && this.state.RDdeviceInfo != undefined ? this.state.RDdeviceInfo : [];
        	var fingerprintData = this.state.CaptureFingerprintData != null && this.state.CaptureFingerprintData ? this.state.CaptureFingerprintData : [];
        
			console.log("FinalDeviceInfo", finalDeviceInfo);
			console.log("FingerprintData", fingerprintData);

        	var dpId = finalDeviceInfo.attributes.dpId != undefined && finalDeviceInfo.attributes.dpId != '' ? finalDeviceInfo.attributes.dpId : '';
        	var dc = finalDeviceInfo.attributes.dpId != undefined && finalDeviceInfo.attributes.dc != '' ? finalDeviceInfo.attributes.dc : '';
        	var mi = finalDeviceInfo.attributes.mi != undefined && finalDeviceInfo.attributes.mi != '' ? finalDeviceInfo.attributes.mi : '';
        	var mc = finalDeviceInfo.attributes.mc != undefined && finalDeviceInfo.attributes.mc != '' ? finalDeviceInfo.attributes.mc : '';
        	var rdsId = finalDeviceInfo.attributes.rdsId != undefined && finalDeviceInfo.attributes.rdsId != '' ? finalDeviceInfo.attributes.rdsId : '';
        	var rdsVer = finalDeviceInfo.attributes.rdsVer != undefined && finalDeviceInfo.attributes.rdsVer != '' ? finalDeviceInfo.attributes.rdsVer : '';
       		// var dc = finalDeviceInfo.attributes.dc != undefined && finalDeviceInfo.attributes.dc != '' ? finalDeviceInfo.attributes.dc : '';
        	var skey = fingerprintData.children[2].value != undefined ? fingerprintData.children[2].value : '';
        	var udc = fingerprintData.children[1].dc != undefined ? fingerprintData.children[1].dc : '';
        	var hmac = fingerprintData.children[3].value != undefined ? fingerprintData.children[3].value : '';
        	var pidtype = fingerprintData.children[4].attributes.type != undefined ? fingerprintData.children[4].attributes.type : '';
        	var ciId = fingerprintData.children[2].attributes.ci != undefined ? fingerprintData.children[2].attributes.ci : '';
        	var pid = fingerprintData.children[4].value != undefined ? fingerprintData.children[4].value : '';

			console.log("FingerprintData children : ", fingerprintData.children);

			const bioEkycRequest = {
				"request": {
					"requestId": this.props.orderDetails.orderId,
					"requestRemarks": "Bio ekyc",
					"merchantLoginId": this.props.orderDetails.roMdn,
					"primaryKeyId": this.state.primaryKeyId,
					"encodeFPTxnId": this.state.encodeFPTxnId,
					"deviceImei": "F58032B1-496D-44E1-950F-BB8DC4F362A9",
					"timestamp": this.state.curTime,
					"p2CardDetails": {
						"adhaarNumber": this.props.aadhaarNumber,
						"indicatorforUID": 0,
						"nationalBankIdentificationNumber": ""
					},
					"captureData": {
						"errCode": "0",
						"errInfo": "Capture Success",
						"fCount": "2",
						"fType": "0",
						"iCount": "0",
						"iType": "0",
						"pCount": "0",
						"pType": "0",
						"nmPoints": "32,32",
						"qScore": "69,69",
						"dpID": dpId,
						"rdsID": rdsId,
						"rdsVer": rdsVer,
						"dc": dc,
						"mi": mi,
						"mc": mc,
						"ci": ciId,
						"sessionKey": skey,
						"hmac": hmac,
						"PidDatatype": pidtype,
						"Piddata": pid
					}
				}
			}

			console.log('Bio Ekyc request', bioEkycRequest);

			var bioEkycUrl = process.env.REACT_APP_FingPay_Bio_Ekyc_URL;

			console.log('Bio Ekyc url', bioEkycUrl);

			var bioEkycResponse = await ApiCallingService.postMethodCall(bioEkycUrl, bioEkycRequest);

			console.log('Bio Ekyc response', bioEkycResponse);

        	if (!(bioEkycResponse === undefined) && (bioEkycResponse.response_code == 0)) {
				
				store.dispatch(showIciciKycSuccessSection());

				this.setState({messagePopUpHidden: true });
				this.setState({severity: "success" });
				this.setState({message:bioEkycResponse.response_description});
						
			}
			else if (!(bioEkycResponse === undefined) && !(bioEkycResponse.response_description === undefined)) {
				this.setState({messagePopUpHidden: true });
				this.setState({severity: "error" });
				this.setState({message: bioEkycResponse.response_description });
					
			} else {
				this.setState({messagePopUpHidden: true })
				this.setState({message:bioEkycResponse});
				this.setState({severity: "error" });
			}                    
		}
		else if (!(response === undefined) && !(response.response_description === undefined)) {
			this.setState({messagePopUpHidden: true });
			this.setState({severity: "error" });
			this.setState({message: response.response_description });
				
		} else {
			this.setState({messagePopUpHidden: true })
			this.setState({message:response});
			this.setState({severity: "error" });
		}
	}

	checkTermsConditions = (event) => {
		
		console.log('Checked', event.target.checked);

		if (event.target.checked == true) {
			this.setState({ checkTermsConditions: 1 });
		} else {
			this.setState({ checkTermsConditions: 0 });
		}
		
		setTimeout(() => {
			this.formValidation();
	    }, 300);
	}

	formValidation =()=>{
		var is_Disable = false;

		if (this.state.otp === '') {
			is_Disable = true;
		}else if(this.state.checkTermsConditions == 0){
			is_Disable = true; 
		}

		this.setState({ proceedButtonStatus: is_Disable });
	}

    render(){
        return(
		 <>
			<div style={{ display: 'none' }} >
                    <input type="hidden" value="1" id="txtfcount" class="form-control" />
                    <input type="hidden" value="0" id="txtftype" class="form-control" />
                    <input type="hidden" value="0" id="txtformat" class="form-control" />
                    <input type="hidden" value="2.0" id="txtPidVer" class="form-control" />
                    <input type="hidden" value="10000" id="txttimeout" class="form-control" />
                    <input type="hidden" value="P" id="txtenv" class="form-control" />
                    <input type="hidden" value="" id="txtlk" class="form-control" />
                    <textarea id="txtRDSInfo" class="form-control hide"> </textarea>
                    <textarea id="txtDeviceInfo" class="form-control hide"> </textarea>
                    <textarea id="txtPidData" class="form-control hide"> </textarea>
                    <select id="ddlRDS" class="form-control hide"  ><option></option></select>
            </div>
			
           <div className="mid-contant">
	       <div className="container">		
		   <div className="row">
			<div className="col-12">
				<div className="head">
					<h2>ICICI KYC Process</h2>
				</div>
			</div>
			<Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				open={this.state.messagePopUpHidden}
				autoHideDuration={3000}
				onClose={e => this.setState({ messagePopUpHidden: false })}
			>
			<Alert onClose={e => this.setState({ messagePopUpHidden: false })} severity={this.state.severity}>
				{this.state.message}
			</Alert>
			</Snackbar>
			<div className="col-12">
				<div className="kycform">
					<div className="row mb-3">
						<div className="col-12 col-lg-7">
							<form> 
							<div className="row">								
								<div className="col-12 col-md-6">
									<div className="form-floating">
										<input type="text" className="form-control" id="firsname" placeholder="Enter name" name="name" value={this.props.name} disabled={true} />
										<label for="firsname">Full Name</label>
									</div>
								</div>
								
								<div className="col-12 col-md-6">
									<div className="form-floating">
										<input type="text" className="form-control" id="mobile" placeholder="Enter mobile no." name="mobile" value={this.props.mobile} disabled={true} />
										<label for="mobile">Mobile number</label>
									</div>
								</div>
								
								<div className="col-12 col-md-6">
									<div className="form-floating">
										<input type="text" className="form-control" id="lastname" placeholder="Enter Aadhaar" name="aadhaarNumber" value={this.props.aadhaarNumber} disabled={true} />
										<label for="lastname">Aadhaar Number / VID</label>
									</div>
								</div>
								
								<div className="col-12 col-md-6">
									<div className="form-floating">
										<input type="text" className="form-control" id="pan" placeholder="Enter PAN" name="panNumber" value={this.props.panNumber} disabled={true} />
										<label for="pan">PAN Number</label>
									</div>
								</div>
								
								<div className="col-12 col-md-6">
									<div className="form-floating">
										<input type="text" className="form-control" id="otp" placeholder="Verify OTP" name="otp" value={this.state.otp} onChange={this.handleChange} />
										<label for="otp">Verify OTP</label>
										{(this.state.getOtpBtn == true) &&
                  						  <button type="button" className="otpbtn" id="getotp" onClick={this.onClickGetOtp}>Get OTP</button>
										}
               							{(this.state.resendOtpBtn == true) &&
                						  <button type="button" className="otpbtn" id="resend" onClick={this.onClickResendOtp}>Resend</button>
									    }
										</div>
								</div>							
								
								<div className="col-12 mt-4">
									<div className="form-check">
										<input className="form-check-input" type="checkbox" onChange={this.checkTermsConditions} name="checkTermsConditions" value={this.state.checkTermsConditions} id="tnc" />
										<label className="form-check-label tnc" for="tnc">By registering, you confirm that you accept our <a href={process.env.REACT_APP_KYC_Terms_And_Conditions_Link} target="_blank" >terms and conditions</a></label>
									</div>
								</div>
								
								<div className="col-12">
									<div className="scanner connect"><i className={this.state.biomatricDeviceIndicaterClass}></i> {this.state.biomatricDeviceIndicater}</div>
								</div>
								
								<div className="col-12">
								    <button type="button" className="btn btn-primary" id="" disabled={this.state.proceedButtonStatus} onClick={this.submitFormData} >Proceed</button>
								</div>
							</div>
							</form>							
						</div>
						
						<div className="col-12 col-lg-5 d-none d-lg-block">
                            <div className="rightbanner"><img src={RegisterImg} alt="FinxPay" className="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		    </div>
	        </div>
            </div>
		</>
        );
      } 
}

const mapStateToProps = ({ onBoarding: { orderDetails, name, mobile, aadhaarNumber, panNumber } }) => ({
    orderDetails, name, mobile, aadhaarNumber, panNumber
});

export default connect(mapStateToProps, null)(IciciKyc);